'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('monitoring', {
      url: '/monitoring',
      template: '<monitoring></monitoring>'      
    })    
    .state('monitoring-type', {
      url: '/monitoring/:type',
      template: '<monitoring></monitoring>'      
    })
    .state('monitoring-type-id', {
      url: '/monitoring/:type/:id',
      template: '<monitoring></monitoring>'      
    });
}



// WEBPACK FOOTER //
// ./client/app/monitoring/monitoring.routes.js